<template>
	<!-- Hack to get unique parent element, cannot set ref on <a> because of v-if -->
	<span ref="kultunautEventFeedItemRef"></span>
	<a
		v-if="kultunautEvent"
		class="kultunautEventFeedItem js-carousel__item"
		:class="dataProps.class"
		:id="'news__item-' + (dataProps.eventindex + 1) * 10"
		:href="kultunautEvent.link"
		:title="getDictionaryItem('goto') + ' ' + kultunautEvent.title"
		target="blank"
	>
		<Spinner v-show="loading" />
		<div class="grid col kultunautEventFeedItem__inner">
			<div class="col-12 kultunautEventFeedItem-col">
				<h3 class="body-text--small bold kultunautEventFeedItem-title">
					{{ kultunautEvent.title }}
				</h3>
			</div>
			<div class="col-12_smx-6 kultunautEventFeedItem-col">
				<span class="kultunautEventFeedItem-label label--white">
					{{ getDictionaryItem("date") }}
				</span>
				<p class="kultunautEventFeedItem-text">
					{{ kultunautEvent.dateStartFormatted }}
				</p>
			</div>
			<div class="col-12_smx-6 kultunautEventFeedItem-col">
				<span class="kultunautEventFeedItem-label label--white">
					{{ getDictionaryItem("place") }}
				</span>
				<p class="kultunautEventFeedItem-text">
					{{ kultunautEvent.place }}
				</p>
			</div>
			<div class="col-12_smx-6 kultunautEventFeedItem-col">
				<span class="kultunautEventFeedItem-label label--white">
					{{ getDictionaryItem("time") }}
				</span>
				<p class="kultunautEventFeedItem-text">
					{{ kultunautEvent.timeFormatted }}
				</p>
			</div>
			<div class="col-12_smx-6 kultunautEventFeedItem-col">
				<span class="kultunautEventFeedItem-label label--white">
					{{ getDictionaryItem("price") }}
				</span>
				<p class="kultunautEventFeedItem-text">
					{{ kultunautEvent.price }}
				</p>
			</div>
			<span class="kultunautEventFeedItem-icon" v-html="IconCalendar">
			</span>
		</div>
	</a>
</template>

<script setup>
import axios from "axios";
import { onMounted, ref } from "vue";
import IconCalendar from "../../../views/icons/calendar.cshtml";
import Spinner from "../../shared/script/vue/Spinner.vue"

const apiurl = "/api/kultunaut/getfeed";
const kultunautEvent = ref(null);
const loading = ref(true);
const dataProps = ref({});

const kultunautEventFeedItemRef = ref("hekultunautEventFeedItemRefllo");

onMounted(() => {
	dataProps.value = kultunautEventFeedItemRef.value.parentElement.dataset;
	fetchData();
});

const fetchData = async () => {
	let feedAmount = dataProps.value.feedamount;

	try {
		let response = await axios.get(apiurl + "?amount=" + feedAmount);

		if (response.status == 200) {
			kultunautEvent.value = response.data[dataProps.value.eventindex];
		} else {
			kultunautEvent.value = null;
		}

		loading.value = false;

		return response;
	} catch (err) {
		alert(err);
		loading.value = false;
		return false;
	}
};

const getDictionaryItem = (item) => {
	let propertyName = "text" + item;
	var value = dataProps.value[propertyName];
	return value;
};
</script>
